import { useUser } from '../../../hooks/useUser';
import { useMessages } from '../../../hooks/useMessages';
import { SingleMessageDisplay } from './SingleMessageDisplay';
import { useRef, useEffect } from 'react';

export const ActiveMessages = () => {
  const { user } = useUser();
  const { chatMessages } = useMessages();
  const chatRef = useRef<HTMLOListElement>(null);

  useEffect(() => {
    if (chatRef.current) {
      const lastMessage = chatRef.current.querySelectorAll('li')[chatMessages.length - 1];
      lastMessage.scrollIntoView({
        behavior: 'auto',
        block: 'nearest',
      });
    }
  }, [chatMessages]);

  return (
    <>
      {chatMessages?.length > 0 ? (
        <ol ref={chatRef} className="message-bubble-container" id="selected-messages-display">
          {chatMessages.map((message) => {
            return (
              <SingleMessageDisplay
                key={`key-for-single-message-${message.id}`}
                message={message}
                myMessage={message.sender === user?.username}
              />
            );
          })}
        </ol>
      ) : (
        <h2 key={'no-user-signed-in-chat'} id="no-user-signed-in-chat">
          Select A Chat To Open
        </h2>
      )}
    </>
  );
};
